import classNames from 'clsx';
import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { Button as PrimaryButton } from 'reactApp/ui/Button/Button';
import opener from 'reactApp/utils/opener';

import styles from './Button.css';

interface ButtonProps {
    text: string;
    href?: string;
    onClick?: () => void;
    isBlue?: boolean;
}

export const Button = memo(({ text, onClick, href, isBlue }: ButtonProps) => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    const handleClick = useCallback(() => {
        if (href) {
            opener(href);
        }

        onClick?.();
    }, [href, onClick]);

    return (
        <PrimaryButton
            className={classNames(styles.root, {
                [styles.root_mobile]: isMobile,
                [styles.root_blue]: isBlue,
            })}
            theme="vk"
            onClick={handleClick}
        >
            {text}
        </PrimaryButton>
    );
});

Button.displayName = 'Button';
